import { CloudOffline, Rotate } from '@carbon/icons-react';
import classNames from 'classnames';
import * as React from 'react';
import { Body, Icon } from 'vet-bones/design-system/components';
import { isOnPremise, usePortalUser } from 'vet-bones/utils/portal';

import { CloudChecked } from 'src/components/icons/CloudChecked';
import { LaptopChecked } from 'src/components/icons/LaptopChecked';
import { projectSelector } from 'src/selectors/project';
import * as copy from 'src/templates/copy';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

import styles from 'src/containers/ProjectNavbar/projectNavbar.module.scss';

export const ProjectNavbarSaveState: React.VFC = () => {
  const { projectId } = useRouterParams();
  const project = useReduxSelector(projectSelector(projectId));

  const portalUser = usePortalUser();
  const isCloudStorageEnabled = portalUser.data?.is_designer_storage_enabled;

  const isSaving = useReduxSelector((state) => state.ui.isSavingProject);
  const isLaunchpad = isOnPremise();

  if (project?.isCloudProject) {
    if (!isSaving) {
      return (
        <div
          className={classNames(
            styles.projectNavbarSaveState,
            styles.projectNavbarSaveStateFade
          )}
        >
          <Icon IconComponent={CloudChecked} size="md" />
          <Body size="xs">
            {copy.components.project.navbar.saveState.saved(isLaunchpad)}
          </Body>
        </div>
      );
    }
    return (
      <div className={styles.projectNavbarSaveState}>
        <Icon IconComponent={Rotate} size="md" />
        <Body size="xs">{copy.components.project.navbar.saveState.saving}</Body>
      </div>
    );
  }

  if (project?.cloudProjectId) {
    return (
      <div className={styles.projectNavbarSaveState}>
        <Icon IconComponent={CloudOffline} size="md" />
        <Body size="xs">
          {copy.components.project.navbar.saveState.offline}
        </Body>
      </div>
    );
  }

  return isCloudStorageEnabled ? (
    <div
      key={Date.now()}
      className={classNames(
        styles.projectNavbarSaveState,
        styles.projectNavbarSaveStateFade
      )}
    >
      <Icon IconComponent={LaptopChecked} size="md" />
      <Body size="xs">
        {copy.components.project.navbar.saveState.locallySaved}
      </Body>
    </div>
  ) : null;
};
